import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { loadState } from "@/localStorage";
import rootReducer from "@/modules";
import { rejectionNotificationMiddleware } from "./rejectionNotificationMiddleware";

const persistedState = loadState();

const store = configureStore({
  reducer: rootReducer,
  preloadedState: persistedState as any, // PersistedState is a partial state from localStorage
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(rejectionNotificationMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// React-Redux v9+ provides improved TypeScript support with createDispatchHook
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export default store;
